import { render } from "./DsoList.vue?vue&type=template&id=62988555&scoped=true"
import script from "./DsoList.vue?vue&type=script&lang=js"
export * from "./DsoList.vue?vue&type=script&lang=js"

import "./DsoList.vue?vue&type=style&index=0&id=62988555&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62988555"]])

export default __exports__